import { getRequestAction } from 'helpers/functions';

const ACTION_PREFIX = 'scoreItems';

export const getScoreList = getRequestAction(`${ACTION_PREFIX}/getScoreList`);
